<template>
  <div class="container">
    <h4 class="rule-title">百搭通用户服务协议</h4>
    <p>本《百搭通用户服务协议》(以下简称“本服务协议”)是您与上海集勇信息科技有限公司（下称“百搭通”或“我们”）就注册百搭通用户账号及使用服务等相关事宜所订立的协议。为使用百搭通的服务，您应当仔细阅读并遵守本服务协议下的全部内容，特别是涉及免除或者责任限制的条款。如您不同意本服务条款的任意内容，请勿注册或使用百搭通的服务，并应立即停止注册程序。如您勾选“我同意《百搭通用户服务协议》”并通过注册程序或其他任何方式使用或接受百搭通的任何服务，即视为您已阅读并同意本服务协议，自愿接受本服务协议的所有内容的约束。请您在决定注册或使用服务前再次确认您已知悉并完全理解本服务协议的所有内容。</p>

    <p>您需仔细查阅《商户合作协议》之内容。</p>
    <p>1. 我们提供APP软件系统管理、数据管理或与之相关的任何功能。</p>

    <p>第一条 协议的主体与范围</p>
    <p>1.协议主体</p>
    <p>“您”是指经营美容、美发、美甲或相关行业的商户，有实际的经营场所和专业人员为消费者提供服务。您希望通过使用百搭通开发的系统，优化管理提高工作效率，开拓市场营销渠道提升客流量。您需仔细查阅和同意《百搭通商户合作协议》之内容。</p>
    <p>“百搭通”是指上海集勇信息科技有限公司开发的APP软件系统平台。</p>
    <p>“服务” 是指您注册百搭通用户账号，接受并使用我们开发的APP软件系统、数据管理或与之相关的任何程序或功能。</p>

    <p class="item-rule">2.协议内容</p>
    <p>
      本服务协议内容同时包括：
      <br />(1)本《百搭通用户服务协议》文本；
      <br />(2)《商户合作协议》；
      <br />(3)《百搭通隐私政策》：百搭通非常重视您的个人信息和隐私的保护，将按照《百搭通隐私政策》中所公布的政策在具体服务中进行隐私及个人信息的收集、存储、使用、披露等活动。您在注册百搭通账号前，应仔细阅读《百搭通平台隐私政策》；
      <br />(4)第三方服务相关的用户授权协议。为方便您在使用百搭通平台服务的同时，根据您自身需要，通过百搭通平台进行跳转等方式，自愿选择接受独立第三方服务商及部分关联第三方服务商所提供的服务，您将在使用该等第三方服务前对相应的用户授权协议予以同意确认，以作为您和百搭通平台之间就该等第三方服务的使用所涉及的相关事项的权利义务依据。
      <br />上述各项内容之间如存在不一致之处，以时间上最新发布的内容为准。
    </p>

    <p class="item-rule">3.协议遵守</p>
    <p>
      您理解并同意：
      <br />(1)上述“协议内容”中所述的协议、政策、条款与规则构成本服务协议不可分割的组成部分，共同适用于您所使用的百搭通平台服务。
      <br />(2)根据国家法律法规变化、运营需要或为提升服务质量的目的，百搭通将在必要的时候对上述各项协议、条款与规则不时地进行修改更新，并通过在移动客户端上发出公告、站内信等合理、醒目的方式向您进行提前通知。
      <br />(3)您应当及时查阅并了解相关更新修改内容，如您不同意相关更新修改内
      容，可停止使用相关更新修改内容所涉及的服务，此情形下，变更事项对您不产生效力；如您在上述更新修改内容实施后继续使用所涉及的服务，将视为您已同意各项更新修改内容。
    </p>

    <p class="item-rule">4.适用平台</p>
    <p>本服务协议适用于移动客户端(包括IOS、安卓及已有或未来将新增的任何其他移动客户端)等各类平台或媒介中百搭通所提供的各项服务。您知悉并理解，为享受上述相关服务，您必须自行提供相关上网设备并自行负担相关网络使用和商品服务支付所产生的有关费用。</p>

    <p class="item-rule">5.服务内容</p>
    <p>请详见《商户合作协议》之第五条合作内容与功能</p>


    <p class="item-title">
      <b>第二条 账号的使用</b>
    </p>
    <p>
      <span class="item-rule">1.真实身份</span>
      因《网络安全法》等法律法规的规定，您有可能需要在注册或使用该等服务的特定环节中填写真实的身份信息，并需通过相关验证流程后方可使用服务，如您填写的身份信息不完整、不真实或未通过验证，将导致您无法使用该服务、损害自身、他人利益或造成其他不利后果，该等后果将由您予以承担。
    </p>
    <p>
      <span class="item-rule">2.注册信息保护</span>
      百搭通将对您所提交的注册信息予以保护，不会将其披露给任何非关联的第三方，除非：
      (1)相关法律法规或国家机关要求；
      (2)百搭通发生相关合并、分立、收购或资产转移；或
      (3)为提供相关服务所必须的。
      对于您所提交的注册信息中涉及个人信息的内容，百搭通将严格按照《百搭通隐私政策》的规定进行收集、处理和使用。
    </p>
    <p>
      <span class="item-rule">3.账号使用</span>
      您应对您账号项下的所有行为(包括但不限于在线签署任何协议，浏览、购买、支付、点评、上传、发布、输入任何内容)所产生的一切后果负责，通过您的账号所发生的上述各项行为将视为您本人的真实意思表示。
    </p>
    <p>百搭通提示您，您通过自身账号在接受百搭通的各项服务中所上传、发送的任何内容都应具有合法来源，如相关内容涉及任何第三方的合法权益，应事先获得相应的许可。如百搭通收到涉及您的相关举报或投诉，百搭通可采取相关法律法规所要求或允许的方式，向相关争议方、相关部门提供包括账号在内的必要的信息，以便解决纠纷争议，保护正当权利人的合法权益。</p>
    <p>
      <span class="item-rule">4.安全义务</span>
      如您发现账号存在安全问题，请您立即联系百搭通予以调查处理，否则百搭通对潜在损失的产生或扩大不承担任何责任。
    </p>
    <p>百搭通特别提示您，您应该妥善保管您的账号和密码，当您使用完毕百搭通的服务后，您应安全退出。此外，您不应轻信借款、索要密码或其他涉及财产的网络信息。涉及财产操作的，请一定先核实对方身份，并请经常留意百搭通有关防范诈骗犯罪的提示。您知悉并同意，如您在账号信息的保管上、相关上网设备的网络安全维护上存在任何过失导致账号丢失、泄露，您应对此所产生的任何后果负责，百搭通对此不负任何责任，如百搭通因此产生相关支出，百搭通将有权向您予以追偿。</p>
    <p class="item-title">
      <span>第三条 用户行为规范与责任承担</span>
    </p>
    <p>
      <span class="item-rule">1.用户义务</span>
      您知悉并承诺，在使用百搭通所提供的服务的过程中，您应遵守相关法律法规，不应从事如下违反法律法规的规定，影响正常服务提供或损害他人合法利益的行为：
      (1)不应利用百搭通平台或相关服务危害国家安全、破坏政治稳定、泄露国家秘密，不侵犯国家、社会、集体利益和第三方的合法权益，不从事违法犯罪活动，不设立用于实施诈骗，传授犯罪方法，制作或者销售违禁物品、管制物品等违法犯罪活动的网站、通讯群组，不利用网络发布涉及实施诈骗，制作或者销售违禁物品、管制物品以及其他违法犯罪活动的信息；
      (2)不应制作、发布、复制、查阅和传播、存储、链接下列信息：反对宪法所确定的基本原则的；危害国家安全，泄露国家秘密，颠覆国家政权，推翻社会主义制度，煽动分裂国家，破坏国家统一的；损害国家荣誉和利益的；煽动民族仇恨、民族歧视，破坏民族团结的；破坏国家宗教政策，宣扬邪教和封建迷信的；煽动非法集会、结社、游行、示威、聚众扰乱社会秩序的；捏造、散布谣言，侵犯他人权利，扰乱经济、社会秩序，破坏社会稳定的；散布淫秽、色情、赌博、暴力、凶杀、恐怖或者教唆犯罪的；侮辱或者诽谤他人，侵害他人合法权益的；宣扬恐怖主义、极端主义的；违背当地风俗习惯的；含有法律、行政法规禁止的其他内容的；
      (3)不应从事下列危害计算机信息网络安全的活动：对网络服务及相关软硬件设施进行破解、破坏、删除、修改或者增加的；对计算机信息网络中存储或者传输的数据和应用程序进行删除、修改或者增加的；使用软件或硬件等方式窃取他人口令、非法入侵他人计算机系统；故意制作、传播计算机病毒等破坏性程序的；其他危害计算机信息网络安全的活动；
      (4)不应擅自复制和使用网络上未公开和未授权的文件。除相关著作权人明示同意，不应在网络中擅自破解、传播、下载或复制第三人享有著作权的软件或进行其他任何侵害他人知识产权的活动；
      (5)不应私自传播广告信息或以“刷单”等不正当方式帮助他人提升评价或利用评价权利对其他用户、商户实施威胁、敲诈勒索；
      (6)不应因对百搭通相关服务的使用行为导致百搭通卷入政治和公共事件；
      (7)不应通过侵犯第三人合法权益、作弊、扰乱系统、实施网络攻击、恶意套现、刷信誉、批量注册、用机器注册百搭通平台账户、用机器模拟客户端等手段进行交易或参加百搭通或其所授权的第三方发布的任何活动；
      (8)未经百搭通事先书面许可，不应自行或授权、协助任何第三方非法抓取百搭通所展示的任何内容(“非法抓取”是指采用未经百搭通认可的程序或者非正常浏览等技术手段获取内容数据的行为)。
    </p>
    <p>
      <span class="item-rule">2.责任承担</span>
      如您在使用百搭通服务过程中涉及上述行为中的一项或多项，则需要对自己的行为承担法律责任。承担法律责任的形式包括但不限于：对受到侵害者进行赔偿，以及在百搭通首先承担了因您的行为导致的行政处罚或侵权损害赔偿责任等损失(含诉讼费、律师费等相关法律程序费用)后，您应立即给予百搭通等额的赔偿。此外，根据具体违法违规情形，百搭通有权作出独立判断，立即暂停或终止对您提供部分或全部服务，包括锁定、注销、删除帐号等措施。同时，您同意，如因您的行为造成他人经济损失的，百搭通可出于公共利益保护、消费者保护、商业利益保护等原则，在合法合规的前提下，从您在百搭通平台所使用账户(如有)中划扣相应款项，您同意并授权、委托百搭通进行上述划扣操作。
    </p>
    <p>您知悉并理解，如果百搭通发现您的上述违法违规行为，依据相关法律法规的规定，百搭通有权或有义务立即停止相关服务，删除或屏蔽相关违规信息、服务评价，并视情况进行调查取证，保存有关记录，或向国家有关机关举报。同时，百搭通有权自主删除、屏蔽含有该内容的任何数据信息。百搭通将根据国家相关法律法规要求，对依法删除、屏蔽的数据信息予以记录、保存。</p>
    <p>
      <span class="item-rule">3.广告促销</span>
      您理解并同意：为向您提供更为细致、贴心的服务，在经过您的事先确认后，百搭通或百搭通授权、认可的第三方商家、广告商可能通过您注册时填写的手机号码或者电子邮箱向您发送您可能感兴趣的商品服务的广告宣传信息、促销优惠等商业性信息，其方式和范围可不经向您特别通知而变更；如果您不愿意接收此类信息，则您有权通过百搭通平台提供的相应的退订方式进行退订。
    </p>
    <p>您理解并同意，对上述的相关广告信息，您应审慎判断其真实性和可靠性，除法律法规明确规定外，您应对依该广告信息进行的交易负责。</p>
    <p>
      <span class="item-rule">4.使用目的</span>
      除非在特定服务条款或规则中您与百搭通另有约定或百搭通另行予以书面同意，未经百搭通书面同意，您不得使用未经百搭通授权的任何插件、外挂或第三方工具对本服务协议下的服务进行干扰、破坏、修改或施加其他影响。
    </p>
    <p class="item-title">
      <span>第四条 知识产权</span>
    </p>
    <p>
      <span class="item-rule">1.知识产权</span>
      您理解并知悉，除另有书面声明以外，以下信息和内容的知识产权(包括但不限于专利权、著作权、商标权及商业秘密)归百搭通所有：
      (1)在百搭通相关服务中所提供的内容和信息(包括但不限于软件、技术、程序、网页、文字、图片、图像、地图、图标、音频、视频、图表、版面设计、电子文档、数据资料等)；
      (2)百搭通用于提供上述内容和信息的基础设施和平台(包括但不限于应用程序)；
      (3)在百搭通提供相关服务中所使用的各项商标、商业形象、商业标识、技术诀窍、标语、文案等；
      百搭通平台服务的开发、运营、维护等过程中产生的所有数据和信息。
    </p>
    <p>百搭通所拥有的上述权利及所提供服务中所包含的任何内容的知识产权均受到法律保护，未经百搭通事先书面许可，您承诺不应且不应允许或协助任何人以任何形式(包括但不限于通过任何机器人、蜘蛛、截屏等程序或设备)进行使用、出租、出借、分发、展示、复制、修改、链接、转载、汇编、发表、出版、抓取、监视、引用或创造相关衍生作品。</p>
    <p>
      <span class="item-rule">2.用户生成内容</span>
      您理解并同意，您在使用百搭通提供的服务时上传、提交、存储或发布的内容(包括但不限于文字、图片、视频、音频、动画等)均由您原创或已获合法授权。您通过百搭通上传、提交、存储或发布的任何内容的知识产权归属您或原始著作权人所有，您的上传、提交、存储或发布行为不会侵犯他人的知识产权或其他合法权益。
    </p>
    <p>您知悉、理解并同意，您一旦接受本服务协议，即表明您主动将上述内容的非专属、可转让的财产性权利，如著作权(包括但不限于：复制权、发行权、出租权、展览权、表演权、放映权、广播权、信息网络传播权、摄制权、改编权、翻译权、汇编权以及应当由著作权人享有的其他可转让权利)，在全世界范围内永久、免费、独家且不可撤销地授权给百搭通及其关联公司，百搭通及其关联公司可基于该等授权使用上述内容(包括但不限于用于商业用途)或向第三方自主进行任何必要的转授权。该等授权、转授权的使用场景包括但不限于当前或其他任何应用程序、产品或移动终端设备等，且百搭通及其关联公司或百搭通及其关联公司所授权许可的第三方可通过对上述授权内容进行修改、复制、改编、翻译、汇编或制作，形成衍生产品。在不违反相关法律法规的强制性规定、尊重相关原始授权内容的知识产权的基础上，该等衍生产品的相关知识产权归百搭通及其关联公司或百搭通所授权许可的第三方所有。</p>
    <p>您确认并同意授权百搭通及其关联公司以自己的名义或委托专业第三方针对有关您上传、提交、存储或发布的内容(含衍生作品)的侵权行为进行独立自主的维权并获得全部赔偿。维权形式包括但不限于：监测侵权行为、发送维权函、提起诉讼或仲裁、调解、和解等。百搭通及其关联公司有权对维权事宜做出独立决策并予以实施。</p>
    <p>您同意，因您通过百搭通上传、发布的任何内容导致的知识产权侵权问题，您将承担全部责任；如百搭通及其关联公司，或百搭通授权的其他服务提供方因第三方知识产权维权而产生损失，您将等额赔偿。</p>
    <p>本服务协议已经构成《著作权法》第二十五条所规定的书面协议，其效力及于用户在百搭通平台发布的任何受著作权法保护的作品内容，无论该内容形成于本服务协议签订前还是本服务协议签订后。百搭通及百搭通转授权、许可的相关方有权将您在百搭通平台发表的产品使用体验、产品讨论或图片进行使用或者与其他人合作使用，使用范围包括但不限于网站、电子杂志、杂志、刊物、海报、公众号文章、微信小程序等。</p>
    <p>
      <span class="item-rule">3.软件使用</span>
      在使用百搭通相关客户端的过程中，您可能需要下载特定软件。为了改善用户体验、修复漏洞、保障安全性等考虑，百搭通有权对软件进行更新，您应该将相关软件更新至最新版本，否则百搭通将不保证您能正常使用相关软件。
    </p>
    <p>如果您从未经百搭通授权的第三方获取软件或与该软件名称相同的安装程序，百搭通无法保证该软件能够正常使用，由此造成的相关损失，百搭通不予负责。</p>
    <p>
      <span class="item-rule">4.软件使用禁止性规定</span>
      除非百搭通书面许可，您在使用百搭通的软件时不得从事下列任一行为：
      (1)删除、编辑或遮挡软件及其副本上关于著作权、商标或其他权利标识或标
      记的信息；
      (2)复制、发布、出售或出租软件或其任何部分；
      (3)对软件进行反向工程、反向汇编、反向编译，或者以其他方式尝试挖掘、
      提取软件的源代码；
      其他对软件、软件所产生的数据所进行的任何增加、删减、变动的任何行
      为，包含制作、利用、授权各种第三方外挂、插件、系统进行上述行为。
    </p>
    <p class="item-title">
      <span>第五条 协议的终止</span>
    </p>
    <p>
      协议终止情形
      本服务协议于以下任一情形下终止：
      (1)百搭通有权依据本服务协议约定，收回、注销用户账号，此情形下，本服务协议于账号收回、注销之日终止；
      (2)在满足百搭通平台公示的账号注销条件时，您通过应用程序注销百搭通的用户账号，本服务协议于账号注销之日终止。您理解并同意，您已认真阅读、认可《百搭通隐私政策》及其附件一《用户注销协议》[ 根据《电子商务法》第76条第三款规定，电子商务经营者需明示用户信息查询、更正、删除以及用户注销的方式、程序。]，并已了解、同意相关用户注销流程及注销后的权利义务安排；
      (3)百搭通有权根据自身商业安排经过合理的提前通知终止全部百搭通平台服务，本服务协议于百搭通平台全部服务依法定程序及方式终止之日终止。
    </p>
    <p>本服务协议终止后，百搭通将无法继续向您提供任何服务或履行任何其他义务，包括但不限于为您保留或向您披露其原百搭通账号中的任何信息，向您或第三方转发任何未曾阅读或发送过的信息等。</p>
    <p>本服务协议的终止不影响第五条知识产权条款以及其他根据其内容应继续有效的条款的有效性，也不影响本服务协议终止前各方的相关权利和义务，包括但不限于守约方依据本服务协议向违约方追究相应的违约责任。</p>
    <p class="item-title">
      <span>第六条 通知与送达</span>
    </p>
    <p>
      您知悉并认可，百搭通可视情况通过下列任意一种或几种方式向您通知重要信息：
      (1)向您注册时所提交的电子邮箱地址发送电子信息；
      (2)向您注册时所提交的手机号码发送电子信息；
      (3)向您提供的实际地址进行寄送纸质载体信息；
      (4)在客户端显著位置刊登电子信息；
      向百搭通相应客户端的账户的站内信或其他即时通信客户端发送电子信息。
    </p>
    <p>上述电子信息在发送成功或刊登完成后即视为送达。相关纸质载体的发送以相关邮寄凭证上的邮寄日期后的第五个自然日视为送达。</p>
    <p>上述送达方式同样可适用于相关仲裁或司法程序(含起诉、审理、执行等各阶段)。</p>
    <p>您应当保证所提供的联系方式是准确、有效的，并进行适时更新，如因提供的联系方式不准确或怠于更新等不可归责于百搭通的原因，导致相关通知、文件、文书无法送达或及时送达，您将自行承担由此可能产生的法律后果。</p>
    <p class="item-title">
      <span>第七条 不可抗力或其他免责事由</span>
    </p>
    <p>
      <span class="item-rule">6.不可抗力</span>
      您理解并同意，在使用本服务的过程中，可能会遇到不可抗力等风险因素，使本服务协议下的服务发生中断或终止。不可抗力是指不能预见、不能克服并不能避免且对一方或双方造成重大影响的客观事件，包括但不限于信息网络设备维护、信息网络连接故障、电脑、通讯或其他系统的故障、电力故障、罢工、劳动争议、暴乱、起义、骚乱、生产力或生产资料不足、火灾、洪水、风暴、爆炸、战争、政府行为、法律法规变动、司法行政机关的命令、其他不可抗力或第三方的不作为而造成的不能服务或延迟服务等行为。出现上述情况时，百搭通将努力在第一时间与相关部门配合，及时进行修复，但是由此给您造成的损失，百搭通在法律允许的范围内免责。
    </p>
    <p>
      <span class="item-rule">7.其他免责事由</span>
      您理解并同意，在法律允许的范围内，百搭通对以下事由所导致的服务中断或终止不承担责任：
      (1)受到计算机病毒、木马或其他恶意程序、黑客攻击的破坏；
      (2)用户或百搭通的电脑软件、系统、硬件和通信线路出现故障；
      (3)用户操作不当；
      (4)用户通过非百搭通授权的方式使用本服务；
      (5)其他百搭通无法控制或合理预见的情形。
    </p>
    <p>
      <span class="item-rule">3.信息真实性</span>
      百搭通提示您，在使用本服务的过程中，您可能会遇到网络信息或其他用户行为带来的风险，该等风险包含他人匿名或冒名的含有威胁、诽谤、令人反感、非法、误导、欺骗等任何信息或行为所造成任何心理、生理上的伤害或经济损失。请您仔细甄别，并在遇到上述相关不法行为时及时向百搭通或有关机关举报或投诉。百搭通将对相关内容开展日常检查并在收到举报或投诉时进行相应处理，但请您注意，百搭通不对非百搭通所发出或刊登的任何信息的真实性、适用性、合法性承担责任，也不对因第三方侵权行为给您造成的损害负责。
    </p>
    <p>
      <span class="item-rule">4.责任限制</span>
      除非另有明确书面说明，在符合法律法规规定的情况下，百搭通不对其客户端上的信息、内容、材料、产品或服务做任何形式的明示或默示的声明或担保
    </p>
    <p class="item-title">
      <span>第八条 管辖、法律适用与争议解决</span>
    </p>
    <p>本服务协议的成立、生效、履行、解释与纠纷解决，适用中华人民共和国制定的法律法规，并且排除一切冲突法规定的适用。</p>
    <p>如因某项具体服务中的产品或服务问题导致您与百搭通间出现纠纷，您同意，该等纠纷将由适用于该项具体服务的服务条款或规则中所规定的争议解决地的有管辖权人民法院受理。就本服务协议而言，如您因本服务协议文本与百搭通产生争议纠纷，您同意交由本服务协议签订地上海市黄浦区人民法院受理。</p>
    <p class="item-title">
      <span>第十条 其他</span>
    </p>
    <p>
      <span class="item-rule">1.关键词</span>
      本服务协议各条款前所列关键词仅供帮助理解条款主旨及快速定位查询条款所用，不能代替条款的任何内容，亦不作为解释条款的依据，百搭通建议您仔细阅读各条款的具体表述，以维护您的合法权益。
    </p>
    <p>
      <span class="item-rule">5.可分性</span>
      如果本服务协议中任何一条被视为废止、无效或因任何理由不可执行，该条应视为可分的且并不影响任何其余条款的有效性和可执行性。
    </p>
  </div>
</template>

<script>
export default {
  data() {
    return {};
  },

  methods: {}
};
</script>
<style>
page {
  background: #f5f5f5;
}
</style>

<style scoped >
.container {
  background: #fff;
  height: auto;
  width: 100%;
}

.rule-title {
  color: #424242;
  font-size: 22px;
  text-align: center;
  margin-top: 20px;
  width: 100%;
}

p {
  margin: 10px 15px;
  background: #fff;
  font-size: 13px;
  color: #424242;
}

.item-rule {
  text-align: left;
}

.item-title {
  text-align: left;
}

/* .item-title span {
  margin-left: 20px;
} */
</style>



// WEBPACK FOOTER //
// src/views/RTA/CustomerAgreement.vue